import { createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "../../helpers/request";

export const login = createAsyncThunk(
  'auth/login',
  async ({ password, username }) => {
    try {
      const response = await request.post('/auth/local', { identifier: username, password });

      return response;
    } catch (e) {
      return e?.response?.data?.error;
    }
  }
);

export const loginVerify = createAsyncThunk(
  'auth/verify',
  async (_) => {
    try {
      const user = await request.post('/token/verify');

      return user;
    } catch (e) {
      return null;
    }
  }
);

export const userRegister = createAsyncThunk(
  'auth/register',
  async (body) => {
    try {
      const data = await request.post('/auth/local/register', body);

      return data;
    } catch (e) {
      return e?.response?.data?.error;
    }
  }
);

export const updateProfile = createAsyncThunk(
  'auth/update',
  async ({ id, ...body }) => {
    try {
      const data = await request.put(`/users/${id}`, body);

      return data;
    } catch (e) {
      return null;
    }
  }
);

export const sendResetPassword = createAsyncThunk(
  'password/reset/request',
  async (body) => {
    try {
      const data = await request.post(`/auth/forgot-password`, body);

      return data;
    } catch (e) {
      return e?.response?.data?.error;
    }
  }
);

export const resetPassword = createAsyncThunk(
  'password/reset/request',
  async (body) => {
    try {
      const data = await request.post(`/auth/reset-password`, {
        code: body.code,
        password: body.password,
        passwordConfirmation: body.confirmPassword,
      });

      return data;
    } catch (e) {
      return e?.response?.data?.error;
    }
  }
);

export const emailConfirmation = createAsyncThunk(
  'email/confirmation',
  async (body) => {
    try {
      const data = await request.get(`/auth/email-confirmation?confirmation=${body.confirmation}`);

      return data;
    } catch (e) {
      return e?.response?.data?.error;
    }
  }
)